import { makeAutoObservable } from 'mobx'
import ExtendedMap from 'src/models/ExtendedMap'

import { LevelSetting } from './LevelSetting'

// 활성 UI 레벨 번호(1=하, 3=중, 4=상)를 map key에 매핑
// 레벨 2(중하), 5(최상)는 비활성화 상태
const LEVEL_TO_KEY: Partial<Record<number, LevelSetting['key']>> = {
  1: 'veryLow',
  3: 'middle',
  4: 'high',
}

export class LevelSettingColl {
  map: ExtendedMap<'veryLow' | /* 'low' | */ 'middle' | 'high', /* | 'veryHigh' */ LevelSetting>
  constructor(map: ExtendedMap<'veryLow' | /* 'low' | */ 'middle' | 'high', /* | 'veryHigh' */ LevelSetting>) {
    makeAutoObservable(this)
    this.map = map
  }

  get toArr() {
    return [...this.map.values()]
  }

  get isAllValid() {
    return this.toArr.every(({ isValid }) => isValid)
  }

  /** level 번호(1/3/4)로 해당 LevelSetting을 조회 */
  getByLevel(level: number): LevelSetting | undefined {
    const key = LEVEL_TO_KEY[level]
    return key ? this.get(key) : undefined
  }

  /** level 번호(1/3/4)로 difficultySetting을 업데이트 */
  setLevel(level: number, value: [number, number, number, number, number]) {
    const setting = this.getByLevel(level)
    if (setting) setting.difficultySetting = value
  }

  get(key: LevelSetting['key']) {
    return this.map.get(key)
  }
}
